import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	emptyStateHeader: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	emptyStateDescription: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	emptyStateDescriptionMobile: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	viewAllProjects: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	loadMore: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	emptyStateDescriptionIssueTermRefresh: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	viewAllProjectsGalaxia: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	emptyStateDescriptionIssueTermRefreshGalaxia: {
		defaultMessage: string;
		id: string;
		description: string;
	};
} = defineMessages({
	emptyStateHeader: {
		defaultMessage: 'You haven’t worked on anything yet',
		id: 'home.tabs.worked-on.empty-state-header',
		description: 'Empty State header for jira home worked on tab',
	},
	emptyStateDescription: {
		defaultMessage:
			'In this page, you’ll find your recently worked on issues. Get started by finding the project your team is working on.',
		id: 'home.tabs.worked-on.empty-state-description',
		description: 'Empty State description for jira home worked on tab',
	},
	emptyStateDescriptionMobile: {
		defaultMessage: 'On this page, you’ll find your recent work.',
		id: 'home.tabs.worked-on.empty-state-description-mobile',
		description:
			'Empty State description for jira home worked on tab when viewed on a mobile device',
	},
	viewAllProjects: {
		defaultMessage: 'View all projects',
		id: 'home.tabs.worked-on.view-all-projects',
		description:
			'The message show in the button on the empty state of the Recently Viewed tab on Jira Home.',
	},
	loadMore: {
		defaultMessage: 'Load more',
		id: 'home.tabs.worked-on.load-more',
		description: 'A label for a button that will load more issues when clicked',
	},
	emptyStateDescriptionIssueTermRefresh: {
		defaultMessage:
			'In this page, you’ll find your recently worked on work items. Get started by finding the project your team is working on.',
		id: 'home.tabs.worked-on.empty-state-description-issue-term-refresh',
		description: 'Empty State description for jira home worked on tab',
	},
	viewAllProjectsGalaxia: {
		defaultMessage: 'View all spaces',
		id: 'home.tabs.worked-on.view-all-projects-galaxia',
		description:
			'The message show in the button on the empty state of the Recently Viewed tab on Jira Home.',
	},
	emptyStateDescriptionIssueTermRefreshGalaxia: {
		defaultMessage:
			'In this page, you’ll find your recently worked on work items. Get started by finding the space your team is working on.',
		id: 'home.tabs.worked-on.empty-state-description-issue-term-refresh-galaxia',
		description: 'Empty State description for jira home worked on tab',
	},
});
export default messages;
